import digitalData from 'digital-data';
import {
  STASH,
} from '../constants';
import { getState } from '../analytics-state';

export const productHotspots = () => {
  window.LIFE_CYCLE_EVENT_BUS.on('product-hotspots.product-link-click', ({ output }) => {
    const { sku } = output;
    const { dataSources } = getState() || {};
    const { collectionId, curations } = dataSources?.collection || {};
    const curation = (curations && curations.length) ? curations[0] : {};
    const { curationId } = curation || {};

    const ddoEvent = {
      category: {
        primaryCategory: STASH
      },
      eventMode: STASH,
      eventInfo: {
        eventName: 'collections product click'
      },
      stash: {
        collection: {
          collectionID: collectionId,
          pageLocation: 'hotspots'
        },
        product: [
          {
            productInfo: {
              sku: String(sku)
            },
            curationID: curationId
          }
        ]
      }
    };
    digitalData.event = digitalData.event || [];
    digitalData.event.push(ddoEvent);
  });

};
